<template>
  <el-table-column
    prop="type"
    sortable="custom"
    label="Típus"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.type === 'placement' ? 'Kihelyezés' : 'Törölt' }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'type',
  };
</script>
